import { AuthLevel, generateApiPath } from '@guiker/api-definition'

const paths = {
  asset: generateApiPath({ prefix: AuthLevel.AUTH, name: 'asset' }),
}

export { paths }
